import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthProvider';
import { AdminPage } from './pages/AdminPage';
import { AlbumPage } from './pages/AlbumPage';
import { CoverPage } from './pages/CoverPage';
import { FilmPage } from './pages/FilmPage';
import { LoginPage } from './pages/LoginPage';
import { NoAccessPage } from './pages/NoAccessPage';

function Gate() {
  const { status } = useAuth();
  if (status === 'loading') {
    return (
      <div className="loader">
        <div>
          <div className="diya" />
          <p>Lighting the lamps…</p>
        </div>
      </div>
    );
  }
  if (status === 'denied') return <Navigate to="/access-denied" replace />;
  if (status !== 'ready') return <Navigate to="/login" replace />;
  return <Outlet />;
}

function AdminGate() {
  const { isAdmin } = useAuth();
  if (!isAdmin) return <Navigate to="/" replace />;
  return <Outlet />;
}

export function App() {
  return (
    <AuthProvider>
      <a className="skip" href="#root">
        Skip to album
      </a>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/access-denied" element={<NoAccessPage />} />
        <Route element={<Gate />}>
          <Route path="/" element={<CoverPage />} />
          <Route path="/album" element={<AlbumPage />} />
          <Route path="/film" element={<FilmPage />} />
          <Route element={<AdminGate />}>
            <Route path="/admin" element={<AdminPage />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
